import React, { useEffect, useRef, useState , useContext} from "react";
import "./header.css";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/logos/white-logo.svg";
import { logoutUser } from "../../../api/config";
import { isloggedInFunc } from "../../../api/config";
import { UserDetail } from "../../../api/userApi/UserProfile";
import UserContext from "../../../context/UserContext";
function Header({ onMenuClick, isNavOpen, onMobileMenuClick, onNavSwitch }) {
  const navigate = useNavigate();

  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const profileDropdown = () => {
    setShowProfileDropdown(!showProfileDropdown);
  };
  const { isProfileUpdated, setIsProfileUpdated } = useContext(UserContext);
  console.log("Context:", isProfileUpdated);
  const UserName = localStorage.getItem("username");
  const UserId = Number(localStorage.getItem("UserId"));
  console.log(UserName)

  const [userData, setUserData] = useState({
      UserId: UserId || Number(localStorage.getItem("UserId")),
      UserName: "Not Available",
      Email: "Not Available",
      PhoneNumber: null,
      ProfileImage: null,
      Role: "Not Available",
    });

  const getInitials = (name) => {
    if (!name) return "";

    const parts = name.trim().split(" ");

    // First name first letter
    const firstInitial = parts[0]?.charAt(0).toUpperCase();

    // Last name first letter (if exists)
    const lastInitial =
      parts.length > 1 ? parts[parts.length - 1].charAt(0).toUpperCase() : "";

    return firstInitial + lastInitial;
  };

  const navigateLogin = () => {
    logoutUser(navigate);
  };
  useEffect(() => {
    isloggedInFunc();
  }, []);

  const [active, setActive] = useState(null); // store which box is active
  const profileRef = useRef(null);

    useEffect(() => {
      if (UserId) {
        getUserData();
        setIsProfileUpdated(false); // reset after fetching new data
      }
    }, [isProfileUpdated]);
  
  useEffect(() => {
    if (sessionStorage.getItem("HeaderType")) {
      setActive(sessionStorage.getItem("HeaderType"));
      onNavSwitch(sessionStorage.getItem("HeaderType"));
    } else {
      setActive("blog");
      onNavSwitch("blog");
    }
  });
  const handleClick = (type, route) => {
    setActive(type); // highlight the clicked box
    onNavSwitch(type); // open correct sidebar
    navigate(route); // navigate to route
    sessionStorage.setItem("HeaderType", type);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        profileRef.current &&
        !profileRef.current.contains(event.target)
      ) {
        setShowProfileDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [])


    const getUserData = async () => {
      try {
        const payload = { userId: UserId };
        const response = await UserDetail(payload);
  
        if (response?.data?.result === 1) {
          const result = response.data.result_value;
  
          const roleName =
            result.roleId === 1
              ? "Admin"
              : result.roleId === 3
              ? "SuperAdmin"
              : "User";
  
          setUserData({
            UserId: UserId,  
            UserName: result.userName || "Not Available",
            Email: result.email || "Not Available",
            PhoneNumber: result.phoneNumber ,
            ProfileImage: result.profileImage,
            Role: roleName,
          });
        } else {
          console.error("Failed to fetch user data");
        }
      } catch (err) {
        console.error("Error fetching user data:", err);
      }
    };
  return (
    <>
      <header className={`app-header ${isNavOpen ? "shrinkNav" : ""}`}>
        <div className="header_inner_wraper">
          <div className="header_mobile_logo">
            <img
              src={logo}
              alt="TechFeatures"
              onClick={() => {
                active === "blog"
                  ? navigate("/dashboard")
                  : navigate("/chatBotDashboard");
              }}
            />
          </div>
          {/* <div className="header_menu_icon" onClick={onMenuClick}>
            <i class="bi bi-list"></i>
          </div> */}

          {/* Chatbot & Blog */}
          {/* <div className="chatbot_icon">
            <div
              className={`chatbot_box ${active === "blog" ? "active" : ""}`}
              onClick={() => handleClick("blog", "/dashboard")}
            >
              <i className="bi bi-journal-text"></i> Blog
            </div>

            <div
              className={`chatbot_box ${active === "chatbot" ? "active" : ""}`}
              onClick={() => handleClick("chatbot", "/chatBotDashboard")}
            >
              <i className="bi bi-robot"></i> ChatBot
            </div>
          </div> */}


          <div className="header-txt">
            <h1>Dashboard</h1>
            <p>
              Welcome back! Here's what's happening today.
            </p>
          </div>

          <div className="profile_menu_icon_wraper d-flex align-items-center">
            <div
              className="header_mobile_menu_icon"
              onClick={onMobileMenuClick}
            >
              <i class="bi bi-list"></i>
            </div>

            <div className="profile_dropdown" ref={profileRef}>
              {/* The Trigger Area */}
              <div className="profile_trigger" onClick={profileDropdown}>
                <div className="profile_icon">
                  <img
                    src={userData.ProfileImage || require("../../../assets/images/user-profile.png")}
                    alt="UserProfile"
                  />
                </div>
                <div className="profile_user_name">
                  <span>{getInitials(userData.UserName)}</span>
                  {/* Changed to chevron-down for a more modern feel, but kept your logic */}
                  <i className={`bi bi-chevron-down dropdown_arrow ${showProfileDropdown ? "rotate" : ""}`}></i>
                </div>
              </div>

              {/* The Menu */}
              {showProfileDropdown && (
                <div className="profile_dropdown_menu" onClick={(e) => e.stopPropagation()}>
                  <div className="dropdown_info">
                    <p className="user_full_name">{userData.UserName}</p>
                  </div>
                  <ul>
                    <li onClick={()=>(navigate("/profile"))}>
                      <i className="bi bi-person"></i>
                      <span>Profile</span>
                    </li>
                    <li className="logout_item" onClick={navigateLogin}>
                      <i className="bi bi-box-arrow-left"></i>
                      <span>Logout</span>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
